import { createAction, props } from '@ngrx/store';
import { ClearData } from '@shared/models';

import { IFileMetaData } from '../../reducers/document-upload/document-upload.reducer';

export const updateLetterFilesMetaData = createAction(
  '[Letter Upload] Update Letter Files Metadata',
  props<{ payload: IFileMetaData[] }>(),
);

export const updateVgHasLetter = createAction(
  '[Letter Upload] Update VG has letter',
  props<{ payload: boolean }>(),
);

export const updateLetterProspectClearDocuments = createAction(
  '[Letter Upload] Updating letter prospect clear document(s)',
  props<{ payload: ClearData }>(),
);

export const clearUploadedLetter = createAction('[Letter Upload] Clear letter document(s)');
